export default "__VITE_ASSET__DYXB$HS8__"